import React from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import Pagination from '../../common/Pagination';
import SearchBar from '../../common/Search';
import { setLocationFilters } from '../../redux/features/filtersSlice';
import { useGetLocationQuery } from "../../redux/services/locationService/location.Services";
function Location() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const filter = useSelector((state) => state.filters.Location)
    const { data, isLoading, isError } = useGetLocationQuery(filter);
    // const [deleteState] = useDeleteStateMutation();
    const locationData = data?.data || [];
   
    const pagination = data?.pagination || {};
    const totalPages = pagination?.totalPages || 0;
    const showPagination = totalPages > 1;
    const hasData = setLocationFilters?.length > 0;
    const isActive = (status) => {
        return status === "active" || status === "Active" || status === 1 || status === true;
    };

    const handlePageChange = (page) => {
        dispatch(
            setLocationFilters({
                page,
            })
        );
    };
    const handleSearch = (value) => {
        dispatch(
            setLocationFilters({
                search: value,
                page: 1,
            })
        );
    }
    if (isLoading) {
        return <h3>Loading...</h3>;
    }

    if (isError) {
        return <h3>Something Went Wrong</h3>;
    }

    return (
        <div>

            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">

                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">

                    <nav>

                        <h4 className="fw-semibold">
                            All Location
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li className="breadcrumb-item active">
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li className="breadcrumb-item">
                                All Location
                            </li>

                        </ol>

                    </nav>

                </div>

                <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                        onClick={() => navigate("/create-location")}
                        className="btn btn-primary me-2"
                    >
                        Add Location
                    </button>

                </div>

                <div className=" mb-4">
                    <SearchBar
                        search={filter.search}
                        setSearch={handleSearch}
                        placeholder="Search  Categories..."
                    />

                </div>
            </div>

            {/* TABLE */}
            <div className="st-wrapper-card">

                <div className="st-table-responsive">

                    <table className="table st-custom-table align-middle mb-0">

                        <thead>

                            <tr>
                                <th>Sr.No</th>

                                <th>Location</th>
                                <th>State Name</th>
                                <th>City Name</th>
                                <th>Status</th>
                                <th>Changes Status</th>
                                <th className="text-center">
                                    Action
                                </th>
                            </tr>

                        </thead>

                        <tbody>

                            {
                                locationData.map((item, index) => (

                                    <tr key={item.id}>
                                        <td>
                                            {index + 1}
                                        </td>

                                        <td className="fw-semibold">
                                            {item?.name}
                                        </td>
                                        <td className="fw-semibold">
                                            {item?.stateName}
                                        </td>
                                        <td className="fw-semibold">
                                            {item?.cityName}
                                        </td>
                                        <td className="fw-semibold">

                                            {
                                                item.status === "active"
                                                    ? "Active"
                                                    : "Inactive"
                                            }

                                        </td>
                                        <td style={{ width: "150px" }}>
                                            <div className="city-status-switch">

                                                <input
                                                    type="checkbox"
                                                    id={`status-${item.id}`}
                                                    className="city-status-input"
                                                    checked={isActive(item.status)}

                                                    onClick={() =>
                                                        dispatch(
                                                            openModal({
                                                                type: "status-state",
                                                                title: "Change State Status",
                                                                // data: {
                                                                //     id: item.id,
                                                                //     name: item.name,
                                                                //     status: item.status,
                                                                //     apiUrl: "state-status",
                                                                // },
                                                                data: {
                                                                    id: item.id,
                                                                    name: item.name,
                                                                    status: item.status,
                                                                    apiUrl: "/location-status",
                                                                    message: `You want to change status of ${item.name}`
                                                                }
                                                            })
                                                        )
                                                    }
                                                />

                                                <label
                                                    htmlFor={`status-${item.id}`}
                                                    className="city-status-label"
                                                >
                                                    <span className="city-status-ball"></span>

                                                    <span className="city-status-text">
                                                        {isActive(item.status)
                                                            ? "Active"
                                                            : "Inactive"}
                                                    </span>
                                                </label>

                                            </div>
                                        </td>
                                        <td className="text-center">

                                            {/* VIEW */}
                                            <button
                                                className="st-action-btn st-view-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-location",
                                                            title: "View Location",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEye />
                                            </button>

                                            {/* EDIT */}
                                            <button
                                                className="st-action-btn st-edit-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-location",
                                                            title: "Edit Location",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEdit />
                                            </button>

                                            {/* DELETE */}
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "delete-state",
                                                            title: "Delete State",
                                                            data: {
                                                                id: item.id,
                                                                apiUrl: "/location-delete",
                                                                message: `You are deleting ${item.name}`,
                                                            },
                                                        })
                                                    )
                                                }
                                            >
                                                <FaTrash />
                                            </button>

                                        </td>

                                    </tr>

                                ))
                            }

                        </tbody>

                    </table>
                    <div className="d-flex justify-content-end mt-4">

                        {showPagination && (
                            <div className="d-flex justify-content-end mt-4">
                                <Pagination
                                    page={filter.page}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}

                    </div>
                </div>

            </div>

        </div>
    );
}

export default Location;